import { createStyles } from "antd-style";

export const useProfileAvatarStyles = createStyles(({ css }: any) => ({
  root: css``,
}));
